class CreateNoteForm extends HTMLElement {
  constructor() {
    super();
    this.innerHTML = `
      <form id="createNoteForm" class="note-form">
        <h3>New Note</h3>
        <div class="form-group">
          <label for="noteTitleNew">Title</label>
          <input type="text" id="noteTitleNew" maxlength="100" placeholder="Type your note title" required />
          <div class="validation">Please enter a title of at least 3 characters.</div>
        </div>
        <div class="form-group">
          <label for="noteBodyNew">Content</label>
          <textarea id="noteBodyNew" rows="5" maxlength="1000" placeholder="Type your note content" required></textarea>
          <div class="validation">Please enter note content of at least 10 characters.</div>
        </div>
        <div class="form-actions">
          <button type="button" id="closeForm">Close</button>
          <button type="submit" disabled>Create</button>
        </div>
      </form>
    `;

    this.titleInput = this.querySelector("#noteTitleNew");
    this.bodyInput = this.querySelector("#noteBodyNew");
    this.submitButton = this.querySelector("button[type='submit']");

    this.titleInput.addEventListener("input", () => this.validateInput(this.titleInput, 3));
    this.bodyInput.addEventListener("input", () => this.validateInput(this.bodyInput, 10));
  }

  connectedCallback() {
    const closeBtn = this.querySelector('#closeForm');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        const formEl = this.querySelector('#createNoteForm');
        if (formEl) formEl.reset();
        if (typeof this.checkFormValidity === 'function') this.checkFormValidity();
        document.body.classList.remove('show-create');
        const strip = document.querySelector('.new-strip');
        if (strip) strip.classList.remove('active');
      });
    }
  }

  validateInput(input, minLength) {
    const validationMessage = input.parentElement.querySelector(".validation");
    if (input.value.length < minLength) {
      input.parentElement.classList.add("invalid");
      validationMessage.style.display = "block";
    } else {
      input.parentElement.classList.remove("invalid");
      validationMessage.style.display = "none";
    }
    this.checkFormValidity();
  }

  checkFormValidity() {
    if (this.titleInput.value.length >= 3 && this.bodyInput.value.length >= 10) {
      this.submitButton.removeAttribute("disabled");
    } else {
      this.submitButton.setAttribute("disabled", "true");
    }
  }
}

customElements.define("create-note-form", CreateNoteForm);
